{
  "general": {
    "noPermission": "Bạn không có quyền xem cài đặt hệ thống.",
    "loading": "Đang tải cài đặt chung",
    "versionLabel": "Phiên bản",
    "lastEditedBy": "Chỉnh sửa lần cuối bởi {{name}}",
    "reload": "Tải lại",
    "platformIdentity": {
      "title": "Nhận diện nền tảng",
      "description": "Thương hiệu hiển thị trên các cổng admin, merchant và vendor."
    },
    "platformName": {
      "label": "Tên nền tảng",
      "hint": "2 đến 100 ký tự."
    },
    "logo": {
      "label": "Logo",
      "helper": "PNG / JPEG / SVG ≤ 5 MB"
    },
    "favicon": {
      "label": "Favicon",
      "helper": "ICO / PNG / SVG ≤ 5 MB"
    },
    "localeTime": {
      "title": "Ngôn ngữ & thời gian",
      "description": "Giá trị mặc định áp dụng khi người dùng chưa thiết lập tùy chọn cá nhân."
    },
    "defaultLocale": {
      "label": "Ngôn ngữ mặc định"
    },
    "defaultTimezone": {
      "label": "Múi giờ mặc định (IANA)"
    },
    "dateFormat": {
      "label": "Định dạng ngày mặc định",
      "options": {
        "vi": "DD/MM/YYYY (Việt Nam)",
        "us": "MM/DD/YYYY (Mỹ)",
        "iso": "YYYY-MM-DD (ISO 8601)"
      }
    },
    "sessionTimeout": {
      "label": "Thời gian hết phiên (phút)",
      "hint": "Từ 5 đến 480 phút."
    },
    "maintenance": {
      "title": "Chế độ bảo trì",
      "description": "Bật bảo trì trực tiếp phải qua phê duyệt kép. Chỉnh sửa ở đây chỉ lưu cấu hình tạm — tác vụ 50 mới điều khiển quy trình bật / tắt.",
      "bannerActive": "Bảo trì hiện đang được đánh dấu KÍCH HOẠT trong cấu hình tạm — hãy gửi qua quy trình phê duyệt kép trước khi nó có hiệu lực.",
      "bannerInactive": "Bảo trì chưa kích hoạt. Các thay đổi tạm sẽ không được triển khai nếu không qua quy trình phê duyệt kép.",
      "activeLabel": "Kích hoạt (tạm)",
      "optionInactive": "Tắt",
      "optionActive": "Kích hoạt (cần phê duyệt)",
      "messageLabel": "Thông báo banner",
      "messagePlaceholder": "Chúng tôi đang nâng cấp hệ thống — sẽ trở lại ngay.",
      "durationLabel": "Thời lượng dự kiến (giờ, 0-168)",
      "bypassLabel": "IP được bỏ qua (phân tách bằng dấu phẩy)",
      "bypassPlaceholder": "10.0.0.1, 192.168.1.42"
    }
  },
  "merchantConfigs": {
    "noPermission": "Bạn không có quyền xem cài đặt hệ thống.",
    "loading": "Đang tải cấu hình merchant",
    "versionLabel": "Phiên bản",
    "lastEditedBy": "Chỉnh sửa lần cuối bởi {{name}}",
    "reload": "Tải lại",
    "invalidJsonFallback": "JSON không hợp lệ",
    "draftSignup": {
      "title": "Hành vi bản nháp & đăng ký",
      "description": "Giá trị vòng đời mặc định áp dụng cho mọi merchant mới tạo."
    },
    "autoCancel": {
      "label": "Tự hủy bản nháp sau (phút)",
      "hint": "Giá trị 0 sẽ tắt việc tự hủy merchant nháp."
    },
    "survey": {
      "label": "Mã khảo sát đăng ký",
      "placeholder": "(để trống để tắt khảo sát)"
    },
    "tier": {
      "title": "Phân hạng",
      "description": "Khoảng thời gian dùng để tổng hợp doanh số merchant nhằm tính hạng thành viên."
    },
    "tierWindow": {
      "label": "Khoảng đánh giá hạng",
      "lifetime": "Trọn đời",
      "lastDays": "{{days}} ngày gần nhất"
    },
    "tierRules": {
      "label": "Quy tắc hạng (mảng JSON)",
      "parseError": "Lỗi phân tích JSON: {{message}}",
      "hint": "Mỗi mục là { \"tier\": \"...\", \"criteria\": { ... } }."
    },
    "creditRules": {
      "title": "Quy tắc tín dụng mặc định",
      "description": "Bản ghi JSON tự do. Được kiểm tra phía máy chủ theo schema namespace merchant.",
      "parseError": "Lỗi phân tích JSON: {{message}}"
    },
    "atRisk": {
      "title": "Ngưỡng Merchant rủi ro",
      "description": "Các ngưỡng kích hoạt đưa merchant vào nhóm rủi ro hiển thị trên bảng điều khiển SuperAdmin.",
      "lowRating": "Đánh giá thấp dưới",
      "rejection": "Tỷ lệ từ chối cao trên (%)",
      "complaintCount": "Bùng phát khiếu nại (số lượng)",
      "complaintWindow": "Khoảng khiếu nại (giờ)"
    }
  },
  "orderConfigs": {
    "loading": "Đang tải Order settings…",
    "loadErrorTitle": "Không tải được Order settings",
    "loadErrorFallback": "Không tải được Order settings — vui lòng thử lại.",
    "saveErrorFallback": "Lưu Order settings thất bại — vui lòng thử lại.",
    "retry": "Thử lại",
    "heading": "Order Configs",
    "description": "Cấu hình tỷ giá (FX), đánh số hoá đơn, auto-push, và ngưỡng SLA escalation cho đơn hàng. Mỗi lần Save ghi audit log + tăng version.",
    "conflict": {
      "title": "Phiên bản đã thay đổi",
      "fallback": "Settings đã được người khác cập nhật trong lúc bạn đang sửa.",
      "reloadHint": "Vui lòng tải lại trang và thử lại.",
      "reload": "Tải lại từ server"
    },
    "saved": "Đã lưu (version {{version}}).",
    "fx": {
      "legend": "Tỷ giá (FX)",
      "sourceLabel": "Nguồn tỷ giá",
      "spreadLabel": "Spread (%) — biên độ cộng thêm vào tỷ giá gốc"
    },
    "fxSourceOptions": {
      "ecb": "ECB (European Central Bank)",
      "xe": "XE.com",
      "manual": "Thủ công (admin nhập)"
    },
    "invoice": {
      "legend": "Đánh số hoá đơn",
      "patternLabel": "Mẫu đánh số (tokens: YYYY, MM, DD, XXXXX)",
      "patternValid": "Mẫu hợp lệ — phải bắt đầu bằng \"INV-\".",
      "patternInvalid": "Mẫu không hợp lệ — phải bắt đầu bằng \"INV-\".",
      "previewLabel": "Preview:",
      "cronLabel": "Cron tự sinh hoá đơn (định dạng cron 5 trường)"
    },
    "autoPush": {
      "legend": "Auto-push & SLA escalation",
      "delayLabel": "Auto-push delay (giây) — thời gian chờ trước khi gửi đơn sang vendor",
      "slaLabel": "Low-stock escalation SLA (giờ) — mặc định 48h",
      "shippingZonesLabel": "Shipping zones link (URL — trang quản lý zone bên ngoài, optional)"
    },
    "capacity": {
      "legend": "Capacity alert thresholds (mặc định 80/95/100)",
      "low": "Low (warning sớm)",
      "warning": "Warning",
      "critical": "Critical"
    },
    "dirtyIndicator": "Có thay đổi chưa lưu",
    "versionIndicator": "Version {{version}}",
    "discard": "Huỷ thay đổi",
    "save": "Save Changes",
    "saving": "Đang lưu…"
  },
  "vendorConfigs": {
    "noPermission": "Bạn không có quyền xem cấu hình hệ thống.",
    "loading": "Đang tải cấu hình vendor",
    "versionLabel": "Version",
    "lastEditedBy": "Chỉnh sửa lần cuối bởi {{name}}",
    "reload": "Tải lại",
    "payouts": {
      "title": "Thanh toán",
      "description": "Chu kỳ và thời gian giữ tiền theo từng hạng mà các đợt thanh toán vendor tuân theo.",
      "scheduleLabel": "Lịch thanh toán"
    },
    "payoutScheduleOptions": {
      "weekly_friday": "Hàng tuần (Thứ Sáu)",
      "biweekly": "Hai tuần một lần",
      "monthly_first": "Hàng tháng (đầu tháng)",
      "monthly_last": "Hàng tháng (cuối tháng)",
      "on_demand": "Theo yêu cầu"
    },
    "holdTier": {
      "legend": "Thời gian giữ tiền theo hạng (ngày)",
      "empty": "Chưa cấu hình hạng giữ tiền nào. Dùng \"Thêm hạng\" để tạo mặc định tier1=7 / tier2=14 / tier3=21 (theo PLAN).",
      "remove": "Xoá",
      "add": "Thêm hạng"
    },
    "capacity": {
      "title": "Cảnh báo công suất",
      "description": "Ngưỡng sử dụng mà tại đó nền tảng hiển thị cảnh báo công suất trên dashboard SuperAdmin và vendor.",
      "low": "Thấp (%)",
      "warning": "Cảnh báo (%)",
      "critical": "Nghiêm trọng (%)"
    },
    "atRisk": {
      "title": "Ngưỡng Vendor At-Risk",
      "description": "Cùng cấu trúc với bảng At-Risk của merchant — các ngưỡng này kích hoạt widget vendor-at-risk của SuperAdmin.",
      "lowRating": "Đánh giá thấp dưới",
      "highRejection": "Tỷ lệ từ chối cao trên (%)",
      "complaintCount": "Đột biến khiếu nại (số lượng)",
      "complaintWindow": "Khung thời gian khiếu nại (giờ)"
    },
    "lowStock": {
      "title": "SLA leo thang hết hàng",
      "description": "Thời gian hệ thống chờ trước khi leo thang cảnh báo hết hàng của vendor lên hàng đợi SuperAdmin.",
      "slaLabel": "SLA leo thang (giờ, 1-168, mặc định 48)"
    },
    "slaThresholds": {
      "title": "Ngưỡng SLA mặc định",
      "descBefore": "Bản đồ JSON tự do giữa giai đoạn → phút (ví dụ",
      "descAfter": ").",
      "jsonLabel": "default_sla_thresholds (JSON)",
      "parseError": "Lỗi phân tích JSON: {{message}}",
      "invalidJson": "JSON không hợp lệ"
    }
  },
  "notificationsTab": {
    "loading": "Đang tải Notifications settings…",
    "loadErrorTitle": "Không tải được Notifications settings",
    "loadError": "Không tải được Notifications settings — vui lòng thử lại.",
    "retry": "Thử lại",
    "heading": "Notifications",
    "description": "Cấu hình ma trận event × kênh, quiet hours (DND), daily digest, và gateway provider (SMS/Email/Push). Per, secret key được rotate ở tab Security.",
    "versionConflictTitle": "Phiên bản đã thay đổi",
    "versionConflictDefault": "Settings đã được người khác cập nhật trong lúc bạn đang sửa.",
    "versionConflictSuffix": "Vui lòng tải lại trang và thử lại.",
    "reload": "Tải lại từ server",
    "saveErrorFallback": "Lưu Notifications settings thất bại — vui lòng thử lại.",
    "saved": "Đã lưu (version {{version}}).",
    "matrix": {
      "legend": "Event catalog × Channel matrix",
      "eventHeader": "Event",
      "cellAria": "{{event}} qua {{channel}}"
    },
    "channels": {
      "in_app": "Trong ứng dụng",
      "email": "Email",
      "push": "Push",
      "sms": "SMS",
      "slack": "Slack",
      "lark": "Lark"
    },
    "quietHours": {
      "legend": "Quiet hours (DND) + Daily digest",
      "start": "Quiet hours bắt đầu",
      "end": "Quiet hours kết thúc",
      "timezone": "Timezone (IANA)",
      "digestEnable": "Bật daily digest (gộp các thông báo trong ngày)",
      "digestTime": "Giờ gửi (local)",
      "timezonePlaceholder": "Asia/Bangkok"
    },
    "gateways": {
      "legend": "Gateway providers",
      "enable": "Bật",
      "note": "Lưu ý: API key/secret được rotate ở tab Security — tab này chỉ bật/tắt gateway.",
      "twilio": "Twilio (SMS gateway)",
      "vonage": "Vonage (SMS gateway dự phòng)",
      "sendgrid": "SendGrid (Email gateway)",
      "fcm": "FCM (Push notification)"
    },
    "dirty": {
      "unsaved": "Có thay đổi chưa lưu",
      "version": "Version {{version}}"
    },
    "actions": {
      "discard": "Huỷ thay đổi",
      "saving": "Đang lưu…",
      "save": "Save Changes"
    }
  },
  "support": {
    "loading": "Đang tải Support settings…",
    "loadErrorTitle": "Không tải được Support settings",
    "loadError": "Không tải được Support settings — vui lòng thử lại.",
    "retry": "Thử lại",
    "heading": "Support",
    "description": "Cấu hình SLA theo priority, canned responses, auto-assign, và default categories cho support tickets.",
    "versionConflictTitle": "Phiên bản đã thay đổi",
    "versionConflictDefault": "Settings đã được người khác cập nhật trong lúc bạn đang sửa.",
    "versionConflictSuffix": "Vui lòng tải lại trang và thử lại.",
    "reload": "Tải lại từ server",
    "saveErrorFallback": "Lưu Support settings thất bại — vui lòng thử lại.",
    "saved": "Đã lưu (version {{version}}).",
    "sla": {
      "legend": "SLA per priority — đơn vị: phút",
      "priorityHeader": "Priority",
      "firstResponseHeader": "First-response (phút)",
      "resolutionHeader": "Resolution (phút)",
      "validationError": "Mỗi SLA phải là số nguyên dương (> 0 phút)."
    },
    "priorities": {
      "critical": "Nghiêm trọng",
      "high": "Cao",
      "medium": "Trung bình",
      "low": "Thấp"
    },
    "canned": {
      "legend": "Canned responses",
      "empty": "Chưa có canned response nào — nhấn \"Thêm\" để tạo mới.",
      "title": "Tiêu đề",
      "remove": "Xoá",
      "body": "Nội dung (HTML — rich editor được upgrade ở page shell)",
      "add": "+ Thêm canned response"
    },
    "autoAssign": {
      "legend": "Auto-assign config",
      "maxOpen": "Max open tickets per admin",
      "workingStart": "Working hours bắt đầu",
      "workingEnd": "Working hours kết thúc",
      "timezone": "Timezone (IANA)",
      "timezonePlaceholder": "Asia/Bangkok"
    },
    "categories": {
      "legend": "Default ticket categories",
      "list": "Danh sách category (phân tách bằng dấu phẩy)"
    },
    "dirty": {
      "unsaved": "Có thay đổi chưa lưu",
      "version": "Version {{version}}"
    },
    "actions": {
      "discard": "Huỷ thay đổi",
      "saving": "Đang lưu…",
      "save": "Save Changes"
    }
  },
  "emailTemplates": {
    "title": "Mẫu email",
    "subtitle": "Quản lý mẫu email hệ thống (Auth / Orders / Billing / System / …) với i18n EN / VI / FR.",
    "create": "Tạo template",
    "filters": {
      "categoryLabel": "Danh mục",
      "allCategories": "Tất cả",
      "searchLabel": "Tìm theo tên",
      "searchPlaceholder": "Xác nhận đơn hàng…"
    },
    "columns": {
      "name": "Tên",
      "category": "Danh mục",
      "subjectEn": "Tiêu đề (EN)",
      "languages": "Ngôn ngữ",
      "lastUpdated": "Cập nhật gần nhất",
      "actions": "Hành động"
    },
    "loading": "Đang tải…",
    "empty": "Chưa có template — nhấn “{{action}}” để bắt đầu.",
    "rowActions": {
      "edit": "Sửa",
      "delete": "Xoá"
    },
    "confirmDelete": "Xoá template “{{name}}”? Hành động này sẽ ẩn template khỏi danh sách.",
    "toast": {
      "deletedTitle": "Đã xoá template",
      "deleteFailedTitle": "Xoá template thất bại"
    },
    "badge": {
      "complete": "{{loc}} hoàn chỉnh",
      "missing": "{{loc}} còn thiếu"
    },
    "categoryLabels": {
      "Auth": "Xác thực",
      "Orders": "Đơn hàng",
      "Billing": "Thanh toán",
      "System": "Hệ thống",
      "Vendor": "Nhà cung cấp",
      "Merchant": "Merchant",
      "Store": "Cửa hàng",
      "Support": "Hỗ trợ"
    }
  },
  "emailTemplateEditor": {
    "untitledTemplate": "mẫu email",
    "subjectLabel": "Tiêu đề ({{locale}})",
    "bodyLabel": "Nội dung ({{locale}})",
    "bodyAriaLabel": "Nội dung email {{locale}}",
    "previewTextLabel": "Văn bản xem trước",
    "footer": {
      "preview": "Xem trước",
      "testSend": "Gửi thử"
    },
    "variables": {
      "heading": "Biến",
      "keyAriaLabel": "Khoá biến",
      "keyPlaceholder": "order_id",
      "descAriaLabel": "Mô tả biến",
      "descPlaceholder": "ID công khai của đơn hàng"
    },
    "categoryLabels": {
      "Auth": "Xác thực",
      "Orders": "Đơn hàng",
      "Billing": "Thanh toán",
      "System": "Hệ thống",
      "Vendor": "Nhà cung cấp",
      "Merchant": "Merchant",
      "Store": "Cửa hàng",
      "Support": "Hỗ trợ"
    }
  },
  "profile": {
    "card": {
      "title": "Thông tin tài khoản",
      "description": "Cập nhật họ tên, số điện thoại, múi giờ và avatar. Mọi thay đổi được ghi vào audit log."
    },
    "fields": {
      "firstName": "Họ",
      "lastName": "Tên",
      "phone": "Số điện thoại",
      "phonePlaceholder": "+84xxxxxxxxx",
      "timezone": "Múi giờ (timezone)",
      "avatarUrl": "URL Avatar",
      "avatarUrlPlaceholder": "https://…",
      "language": "Ngôn ngữ"
    },
    "success": "Đã lưu thay đổi.",
    "buttons": {
      "save": "Lưu thay đổi",
      "saving": "Đang lưu…"
    }
  },
  "changePassword": {
    "card": {
      "title": "Đổi mật khẩu",
      "description": "Đây là thao tác nhạy cảm — bạn có thể được yêu cầu đăng nhập lại sau khi cập nhật."
    },
    "rules": {
      "len": "Ít nhất 12 ký tự",
      "upper": "Có ít nhất 1 chữ in hoa",
      "num": "Có ít nhất 1 chữ số",
      "special": "Có ít nhất 1 ký tự đặc biệt"
    },
    "validation": {
      "currentRequired": "Vui lòng nhập mật khẩu hiện tại",
      "newMin": "Mật khẩu phải có ít nhất 12 ký tự",
      "newUpper": "Cần ít nhất 1 chữ in hoa",
      "newNum": "Cần ít nhất 1 chữ số",
      "newSpecial": "Cần ít nhất 1 ký tự đặc biệt",
      "confirmRequired": "Vui lòng xác nhận mật khẩu",
      "mismatch": "Mật khẩu xác nhận không khớp",
      "sameAsCurrent": "Mật khẩu mới phải khác mật khẩu hiện tại"
    },
    "fields": {
      "current": "Mật khẩu hiện tại",
      "new": "Mật khẩu mới",
      "confirm": "Xác nhận mật khẩu mới"
    },
    "rulesAria": "Yêu cầu mật khẩu",
    "errors": {
      "invalid": "Mật khẩu hiện tại không đúng hoặc phiên đã hết hạn.",
      "reused": "Mật khẩu đã được sử dụng gần đây. Vui lòng chọn mật khẩu khác.",
      "generic": "Yêu cầu thất bại (HTTP {{status}})",
      "unknown": "Lỗi không xác định"
    },
    "success": "Đã đổi mật khẩu thành công.",
    "buttons": {
      "update": "Cập nhật mật khẩu",
      "updating": "Đang cập nhật..."
    }
  },
  "billingInfo": {
    "card": {
      "title": "Doanh nghiệp",
      "description": "Trường nhạy cảm — cần xác thực gần đây (fresh perms — phiên xác thực mới trong vòng 5 phút). Hệ thống sẽ tự refresh nếu phiên hết hạn."
    },
    "fields": {
      "businessName": "Tên doanh nghiệp",
      "taxId": "Mã số thuế (Tax ID)",
      "billingEmail": "Email xuất hoá đơn",
      "line1": "Địa chỉ (line 1)",
      "city": "Thành phố",
      "postalCode": "Mã bưu chính",
      "country": "Quốc gia"
    },
    "address": {
      "legend": "Địa chỉ xuất hoá đơn"
    },
    "countries": {
      "VN": "Việt Nam",
      "US": "Hoa Kỳ",
      "SG": "Singapore",
      "TH": "Thái Lan",
      "JP": "Nhật Bản",
      "GB": "Vương quốc Anh",
      "FR": "Pháp"
    },
    "errors": {
      "needAtLeastOne": "Hãy nhập ít nhất một trường để cập nhật."
    },
    "success": "Đã lưu thông tin xuất hoá đơn.",
    "buttons": {
      "save": "Lưu thông tin",
      "saving": "Đang lưu…"
    }
  },
  "preferences": {
    "card": {
      "title": "Giao diện & Thông báo",
      "description": "Theme, ngôn ngữ, và kênh nhận thông báo. Theme được lưu cả localStorage lẫn DB (cross-device persistence — đồng bộ giữa các thiết bị)."
    },
    "fields": {
      "theme": "Theme",
      "language": "Ngôn ngữ"
    },
    "themeOptions": {
      "light": "Light (Sáng)",
      "dark": "Dark (Tối)",
      "system": "System (Theo hệ thống)"
    },
    "notifications": {
      "legend": "Thông báo",
      "emailDigest": "Nhận email tổng quan",
      "inApp": "In-app (chuông trên TopBar)",
      "emailPerEvent": "Email cho từng sự kiện",
      "sms": "SMS"
    },
    "success": "Đã lưu tuỳ chọn.",
    "buttons": {
      "save": "Lưu tuỳ chọn",
      "saving": "Đang lưu…"
    }
  },
  "securityCenter": {},
  "setup2fa": {
    "card": {
      "title": "Bảo mật tài khoản",
      "description": "Chọn phương thức 2FA — TOTP (qua app như Google Authenticator) hoặc Email OTP. Thao tác nhạy cảm — yêu cầu xác thực gần đây trong 5 phút."
    },
    "fields": {
      "method": "Phương thức",
      "code": "Nhập mã 6 chữ số"
    },
    "methodOptions": {
      "totp": "TOTP (App)",
      "email": "Email OTP"
    },
    "buttons": {
      "disable": "Tắt 2FA",
      "processing": "Đang xử lý…",
      "startEnroll": "Bắt đầu thiết lập",
      "cancel": "Huỷ",
      "verify": "Xác thực mã",
      "verifying": "Đang xác thực…",
      "done": "Hoàn tất",
      "download": "Tải mã xuống",
      "copy": "Sao chép",
      "copied": "Đã sao chép"
    },
    "enroll": {
      "totpHint": "Quét mã QR bằng app TOTP, hoặc nhập secret thủ công:",
      "qrAlt": "Mã QR TOTP cho 2FA",
      "secretLabel": "Secret: {{secret}}",
      "emailHintBefore": "Đã gửi mã OTP tới ",
      "emailFallback": "email của bạn",
      "emailHintAfter": ". Mã hết hạn sau 10 phút."
    },
    "recovery": {
      "successBold": "Đã bật 2FA thành công.",
      "note": " Lưu các mã khôi phục bên dưới ở nơi an toàn — chỉ hiển thị 1 lần duy nhất."
    },
    "disabled": {
      "message": "Đã tắt 2FA. Hãy bật lại sớm để bảo vệ tài khoản."
    },
    "errors": {
      "impersonateSetup": "Không thể thiết lập 2FA trong phiên impersonate.",
      "impersonateDisable": "Không thể tắt 2FA trong phiên impersonate.",
      "wrongPassword": "Mật khẩu không đúng."
    },
    "status": {
      "enabledTitle": "Xác thực hai lớp đang bật",
      "enabledDesc": "Tài khoản của bạn đang được bảo vệ bằng 2FA. Bạn có thể tắt bên dưới nếu cần."
    },
    "disableConfirm": {
      "passwordLabel": "Nhập mật khẩu để tắt 2FA",
      "passwordPlaceholder": "Mật khẩu hiện tại"
    },
    "trustedDevices": {
      "title": "Thiết bị tin tưởng",
      "description": "Thiết bị bạn đã chọn tin tưởng sẽ bỏ qua mã 2FA khi đăng nhập. Thu hồi thiết bị lạ.",
      "current": "Thiết bị này",
      "revoke": "Thu hồi",
      "unknownDevice": "Thiết bị không xác định",
      "empty": "Chưa có thiết bị tin tưởng."
    }
  },
  "roles": {
    "noPermBefore": "Bạn không có quyền xem danh sách role (cần ",
    "noPermAfter": "). Liên hệ Super Admin để được cấp quyền.",
    "listErrorFallback": "Không thể tải danh sách role",
    "header": {
      "title": "Vai trò & Quyền hạn",
      "subtitle": "Quản lý role + ma trận quyền cho admin/super admin (System > Roles)."
    },
    "createCta": "+ Tạo vai trò tùy chỉnh",
    "toast": {
      "noPermTitle": "Không đủ quyền",
      "noPermDesc": "Chỉ Super Admin mới có thể tạo custom role.",
      "createdTitle": "Đã tạo role",
      "createdDesc": "Role mới đã được thêm vào danh sách."
    },
    "listHeader": "Danh sách role",
    "loading": "Đang tải…",
    "emptyList": "Chưa có role nào.",
    "badge": {
      "builtIn": "Built-in",
      "custom": "Custom"
    },
    "rowMeta": "{{permissions}} quyền · {{members}} thành viên",
    "tablistAria": "Tab Vai trò & Quyền hạn",
    "tabs": {
      "matrix": "Ma trận quyền",
      "data": "Quyền dữ liệu"
    },
    "viewingLabel": "Đang xem:",
    "overrideHintBefore": "Cần override ở mức user (additionalPermissions / deniedPermissions)? Truy cập ",
    "overrideHintAfter": " để cấu hình per-user."
  },
  "conflictDiff": {
    "aria": "Máy chủ có phiên bản mới hơn",
    "title": "Máy chủ có phiên bản mới hơn",
    "description": "Một quản trị viên khác đã cập nhật các thiết lập này trong khi bạn đang chỉnh sửa. Máy chủ hiện ở phiên bản v{{currentVersion}} nhưng bản nháp của bạn dựa trên v{{expectedVersion}}. Chọn Tải lại để bỏ các thay đổi và bắt đầu lại từ giá trị máy chủ, hoặc Ghi đè để gửi lại bản vá lên phiên bản hiện tại (có ghi nhật ký kiểm toán).",
    "noDiffs": "Không phát hiện khác biệt — chỉ khác nhau ở bộ đếm phiên bản.",
    "columns": {
      "field": "Trường",
      "yourValue": "Giá trị của bạn",
      "serverValue": "Giá trị máy chủ"
    },
    "reload": "Tải lại giá trị máy chủ",
    "forceOverwrite": "Ghi đè"
  },
  "stickySaveBar": {
    "aria": "Thay đổi chưa lưu",
    "unsavedChanges": "Bạn có thay đổi chưa lưu.",
    "save": "Lưu thay đổi",
    "discard": "Hủy bỏ",
    "saving": "Đang lưu…",
    "readonly": "Chỉ đọc (không có quyền ghi)"
  },
  "useSettings": {
    "loadFailTitle": "Tải thiết lập thất bại",
    "loadFailFallback": "Không thể tải thiết lập. Vui lòng thử lại.",
    "nothingToSaveTitle": "Không có gì để lưu",
    "nothingToSaveDesc": "Không có trường nào thay đổi kể từ lần lưu trước.",
    "savedTitle": "Đã lưu thiết lập",
    "savedDesc_one": "Đã cập nhật {{count}} trường.",
    "savedDesc_other": "Đã cập nhật {{count}} trường.",
    "conflictTitle": "Máy chủ có phiên bản mới hơn",
    "conflictDesc": "Một quản trị viên khác đã cập nhật các thiết lập này. Hãy xem lại khác biệt.",
    "saveFailTitle": "Lưu thất bại",
    "saveFailFallback": "Không thể lưu thiết lập. Vui lòng thử lại."
  }
}